import useQueryParams from "./useQueryParams";

const QueryParams = ({
  config,
  children
}) => {
  const [query, setQuery] = useQueryParams(config);
  return children({
    query,
    setQuery
  });
};

var QueryParams_default = QueryParams;
export { QueryParams, QueryParams_default as default };